import { ReactNode } from 'react';
import classNames from 'classnames';

export default function FormLayout(props: { children?: ReactNode; className?: string }) {
  return (
    <form>
      <div className={classNames("space-y-6 pb-2", props.className)}>{props.children}</div>
    </form>
  );
}
